/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */
import * as React from 'react';
import { Paths } from '../../../../common/enums/Paths';
import { LogCategory } from '../../../../logger';
import { newGuid } from '../../../../utilities/AppUtils';
import { getAppHost } from '../../../../utilities/TeamsUtils';
import { toQueryString } from '../../../../utilities/Utils';
import { Spinner } from '../../../components';
import { docusignAuthStateKey } from './DocusignAuthHelpers';

declare const DOCUSIGN_CLIENT_ID: string;
declare const DOCUSIGN_AUTH_URL: string;

const docusignAuthApi = DOCUSIGN_AUTH_URL + '/oauth/auth';

export const DocusignAuthLoginStart = (): JSX.Element => {
    const logger = getAppHost().getLogger();
    logger.logTraceInfo(LogCategory.DocusignAuth, 'Calling AuthLoginStart');

    const loginState = newGuid();
    localStorage.setItem(docusignAuthStateKey, loginState);
    const docusignAuthQueryParams = {
        redirect_uri: window.location.origin + Paths.BasePath + Paths.DocusignLoginEnd,
        response_type: 'code',
        client_id: DOCUSIGN_CLIENT_ID,
        state: loginState,
        scope: 'impersonation signature openid',
    };

    const authorizeEndpoint = `${docusignAuthApi}?${toQueryString(docusignAuthQueryParams)}`;

    window.location.assign(authorizeEndpoint);

    return (
        <div style={{ height: '100vh' }}>
            <Spinner />
        </div>
    );
};
